import * as R from 'ramda';
import {createAction} from 'redux-actions';

import * as DashboardApiClient from 'js/creator/dashboard/dashboard_api_client';

// action types
const SUBMIT_ANSWERS = 'SUBMIT_ANSWERS';

// action creators
export const submitAnswers = createAction(
    SUBMIT_ANSWERS,
    DashboardApiClient.submitSmartQuestionsAnswers
);

// reducers
export default {
    [SUBMIT_ANSWERS]: R.identity
};



// WEBPACK FOOTER //
// ./creator/ducks/smart_questions.js